module.exports = window["ReactDOM"];